import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=fe2075b0&scoped=true&"
import script from "./TabLink.vue?vue&type=script&lang=js&"
export * from "./TabLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2075b0",
  null
  
)

export default component.exports